export * from './page-505.component';
